(function( $ ) {

    /**
     * Appelle le service DQE à partir du champ de saisie de l'adresse e-mail
     * Options disponibles :
     *   - server: URL du serveur
     *   - country: code d'un pays précis (3 caractères) OU sélecteur jQuery pointant sur le champ pays
     *   - autocheck: lance la vérification de l'adresse e-mail lorsqu'on quitte le champ e-mail (par défaut = true)
     *   - suggest: Propose des adresses e-mail en autocomplétion lors de la saisie (par défaut = false)
     *   - last_name: sélecteur jquery qui pointe sur le champ nom
     *   - first_name: sélecteur jquery qui pointe sur le champ prénom
     *
     *   Méthodes disponibles :
     *   - check(): lance manuellement le contrôle de l'adresse e-mail
     *
     * Evènements disponibles :
     *   - checking: se lance juste avant la vérification d'une adresse e-mail
     *   - checked(data): se lance dès qu'une adresse e-mail est validée

     *
     * @param {object} options Tableau associatif des options
     * @returns {jQuery}
     */
    $.fn.dqemail = function(options) {

        var myDQE = this;

        //On initialise le conteneur du champ et l'icône de statut s'il y en a (uniquement pour des champs Bootstrap)
        var myDQEContainer = myDQE.closest('div');
        var myDQEIcon = false;
        var myDQEIconMode = false;
        if (myDQEContainer.length) {
            myDQEIcon = myDQEContainer.find('span.glyphicon');
            if (myDQEIcon.length) myDQEIconMode = 'glyphicon';
            else myDQEIcon = myDQEContainer.find('i.fa');
            if (myDQEIcon.length) myDQEIconMode = 'fa';
            else myDQEIcon = false;
        }
        else myDQEContainer = false;

        var settings = $.extend({
            //Paramètres par défaut
            country: 'FRA',
            suggest: false,
            autocheck: true,
            license: '',
            extendedsyntax: 'n',
            checkuser: 'y',
            rectify: 0
        }, options);
        myDQE.settings = settings;

        //On récupère les champs à partir de leur selecteur
        myDQE.server     = settings.server;
        myDQE.license    = settings.license;
        myDQE.suggest    = settings.suggest;
        myDQE.last_name  = settings.last_name ? $(settings.last_name) : false;
        myDQE.first_name = settings.first_name ? $(settings.first_name) : false;
        myDQE.autocheck  = settings.autocheck ? settings.autocheck : false;
        myDQE.rectify    = !!settings.rectify;
        myDQE.extended   = settings.extendedsyntax === 'y' ? 'y' : 'n';
        myDQE.checkuser  = !settings.checkuser || settings.checkuser === 'y' ? 'y' : 'n';
        myDQE.activity   = settings.activity ? $(settings.activity) : false;

        //oauth2 parameters
        myDQE.oauth         = settings.oauth        ? settings.oauth        : false;
        myDQE.client_secret = settings.client_secret? settings.client_secret: false;
        myDQE.grant_type    = "client_email";
        myDQE.token         = "";
        myDQE.tokenTimeout  = 250000;

        myDQE.countryField = settings.country.length === 3 ? false : $(settings.country);
        myDQE.country = settings.country;

        myDQE.asmx = myDQE.server.toLowerCase().indexOf(".asmx") > -1;

        //Paramètres d'appel AJAX par défaut pour .net
        if (myDQE.asmx) {
            $.ajaxSetup({
                type: "POST",
                contentType: "application/json; charset=utf-8",
                data: "{}",
                processData: false,
                dataFilter: function(data) {
                    if (typeof (JSON) !== 'undefined' && typeof (JSON.parse) === 'function') data = JSON.parse(data);
                    else data = eval('(' + data + ')');
                    if (data.hasOwnProperty('d')) return data.d;
                    return data;
                }
            });

            $.ajaxPrefilter(function(options, originalOptions, jqXHR) {
                options.data = JSON.stringify(originalOptions.data);
            });
        }

        if (myDQE.server === 'jsonp') {
            myDQE.ajax = function(url, callback) {
                $.ajax({
                    url: url,
                    dataType: 'jsonp',
                    jsonp: 'callback',
                    success: function(data) {
                        callback(JSON.parse(data));
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        var response = {code: 99, msg: 'Service non disponible', state: 'error'};
                        callback(response);
                        myDQE.trigger('checked', [response]);
                        myDQE.bootstrapState(response.state);
                    }
                });
            };
        }
        else {
            if (myDQE.server === 'cors') {
                myDQE.ajax = function(url, callback) {
                    $.ajax({
                        url: url,
                        method: 'GET',
                        dataType: 'text',
                        crossdomain: true,
                        success: function(data) {
                            var response = data ? JSON.parse(data) : {};
                            if(data.hasOwnProperty('IdError')){
                                myDQE.trigger('checked', [response]);
                            }
                            callback(response);
                        }
                    });
                };
            }
            else {
                myDQE.ajax = function (url, from = "not_specified", callback) {
                    $.ajax({
                        url: myDQE.server,
                        data: {url: url, from: from},
                        method: 'POST',
                        dataType: 'json',
                        success: function (data) {
                            callback(data);
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            var response = {code: 99, msg: 'Service non disponible', state: 'error'};
                            callback(response);
                            myDQE.trigger('checked', [response]);
                            myDQE.bootstrapState(response.state);
                        }
                    });
                };
            }
        }

        myDQE.render_item = function (ul, item) {
            var s = item.label;
            var p = s.indexOf("@");
            var highlighted;
            if (p > -1) {
                var user = s.substr(0, p);
                var domain = s.substr(p + 1);
                //#3276b4 ou #69f
                p = domain.lastIndexOf(".");
                if (p > -1) {
                    domain = '<span style="color:#070">' + domain.substr(0, p) + '</span><span style="color:#888">' + domain.substr(p) + '</span>';
                }
                else domain = '<span style="color:#070">' + domain + '</span>';
                highlighted = '<span style="color:#3276b4">' + user + '</span>@' + domain;
            }
            else {
                highlighted = '<span style="color:#3276b4">' + s + '</span>';
            }

            return $("<li></li>")
                .data("item.autocomplete", item)
                .append("<div>" + highlighted + "</div>")
                .appendTo(ul);
        };

        myDQE.remove_accents = function(s) {
            var ko = 'ÀÁÂÃÄÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÇçàáâãèéêëîïòôõöùúûüñ';
            var ok = 'AAAAAEEEEIIIIOOOOOUUUUCcaaaaeeeeiioooouuuun';
            var len = s.length;
            var p;
            var c;
            var result = "";
            for (var i = 0; i < len; i++) {
                c = s.charAt(i);
                p = ko.indexOf(c);
                result += p === -1 ? c : ok.charAt(p);
            }
            return result;
        };

        myDQE.check = function(from) {
            var input = myDQE.val();
            if (input) {
                myDQE.trigger('checking');
                myDQE.bootstrapState('loading');

                var clean_mail = myDQE.remove_accents(input);
                var autocorrect = false;
                if (clean_mail !== input) {
                    myDQE.val(clean_mail);
                    autocorrect = true;
                }
                // var parameters = {fn: "DQEEMAILLOOKUP", Email: encodeURIComponent(clean_mail), extendedsyntax: myDQE.extended, checkuser: myDQE.checkuser};
                var parameters = {fn: "DQEEMAILLOOKUP", Email: clean_mail};
                if (myDQE.rectify) parameters['Rectify'] = 1;
                var url = myDQE.url(parameters);
                myDQE.ajax(url, from, function(data) {
                    var ko = {code: 99, msg: 'Le domaine ne répond pas', state: 'error'};
                    if (!data || !data[1]) return ko;

                    var code = data[1]['IdError'];
                    var parts = input.split('@');
                    var messages = {
                        '91': "Erreur de syntaxe",
                        '92': "Domaine " + parts[1] + " inconnu",
                        '93': "Domaine " + parts[1] + " en blacklist",
                        '94': "Nom d'utilisateur non autorisé (nom réservé ou interdit)",
                        '95': "Adresse e-mail temporaire jetable",
                        '99': 'Le domaine ne répond pas',
                        '04': "E-mail non fourni",
                        '03': "Boîte de réception pleine",
                        '02': "Adresse e-mail non trouvée sur le domaine " + parts[1],
                        '01': "E-mail correct mais le nom " + parts[0] + " n'a pas pu être contrôlé",
                        '00': "E-mail valide"
                    };

                    var activity = {
                        100 :	'email utilisé au moins une fois',
                        201 :	'email actif le mois dernier',
                        202 :	'email actif dans les 2 derniers mois',
                        203 :	'email actif dans les 3 derniers mois',
                        204 :	'email actif dans les 4 derniers mois',
                        206 :	'email actif dans les 6 derniers mois',
                        209 :	'email actif dans les 9 derniers mois',
                        212 :	'email actif dans les 12 derniers mois',
                        300 :	'email actif il y a plus de 12 mois'
                    };

                    var states = {'91': 'error', '92': 'error', '93': 'error', '94': 'error', '99': 'error', '04': 'error', '03': 'error', '02': 'error', '01': 'warning', '00': 'success', '95': 'error'};
                    if (!states[code]) code = '01';
                    var response = {code: code, msg: messages[code], state: states[code], activity: ""};
                    if ((code === '00' || code === '01') && autocorrect) {
                        response['autocorrect'] = 1;
                        response['input'] = input;
                    }

                    data = data[1];
                    if (data['Redressement'] && data['eMail'] !== data['eMailOrigine']) {
                        response['suggestion'] = data['eMail'];
                        if (myDQE.rectify && (code === '01' || code === '02' || code === '91' || code === '92')) response['rectified'] = true;
                    }

                    if(code === '00' || code === '01'){
                        response['activity'] = data['CodeActivite'] in activity ? activity[data['CodeActivite']] : '';
                        if(myDQE.activity) $(myDQE.activity).val(response['activity']);
                    }
                    else{
                        if(myDQE.activity) $(myDQE.activity).val('');
                    }

                    myDQE.trigger('checked', [response]);
                    myDQE.bootstrapState(response.state);
                });
            }
        };

        myDQE.isIE = function() {
            var ua = navigator.userAgent;
            return ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1 || ua.indexOf('Edge/') > -1;
        };

        myDQE.clearBootstrapState = function() {
            if (myDQEContainer) myDQEContainer.removeClass('has-success').removeClass('has-warning').removeClass('has-error');
            if (myDQEIcon) {
                if (myDQEIconMode == 'glyphicon') myDQEIcon.removeClass('glyphicon-ok').removeClass('glyphicon-warning-sign').removeClass('glyphicon-remove');
                else myDQEIcon.removeClass('fa-check').removeClass('fa-warning').removeClass('fa-remove').removeClass('fa-spin').removeClass('fa-cog');
            }
        };

        myDQE.bootstrapState = function(state) {
            myDQE.clearBootstrapState();
            if (state) myDQEContainer.addClass("has-" + state);
            var signs, sign;
            if (myDQEIcon) {
                if (myDQEIconMode === 'glyphicon') {
                    //glyph icons
                    signs = {success: 'ok', warning: 'warning-sign', error: 'remove'};
                    sign = signs[state];
                    if (state) myDQEIcon.addClass("glyphicon-" + sign);
                }
                else {
                    //font-awesome
                    signs = {success: 'check', warning: 'warning', error: 'remove', loading: 'cog'};
                    sign = signs[state];
                    if (state) myDQEIcon.addClass("fa-" + sign);
                    if (state == 'loading' && !myDQE.isIE()) myDQEIcon.addClass("fa-spin");
                }
            }
        };

        myDQE.selected_country  = function() {
            if (myDQE.countryField) return myDQE.countryField.val();
            return myDQE.country;
        };

        myDQE.removeAutocomplete = function(element) {
            if (element.data('ui-autocomplete')) {
                element.autocomplete("destroy");
                element.removeData("ui-autocomplete");
            }
        };

        if (myDQE.autocheck) {
            myDQE.on('blur', function() {
                myDQE.check();
            });
        }

        if (myDQE.suggest) {
            myDQE.removeAutocomplete(myDQE);
            myDQE.autocomplete({
                source: function(request, response) {
                    //MAILSUGGEST/?Nom=$last_name&Prenom=$first_name&Email=$encoded_email&Instance=0&Pays=$country
                    var last = myDQE.last_name ? myDQE.remove_accents(myDQE.last_name.val().toLowerCase()) : '';
                    var first = myDQE.first_name ? myDQE.remove_accents(myDQE.first_name.val().toLowerCase()) : '';
                    var input = myDQE.remove_accents(request.term.toLowerCase());
                    var url = myDQE.url({fn: "MAILSUGGEST", Nom: last, Prenom: first, Email: input, Instance: 0, Pays: myDQE.selected_country()});
                    var suggestions = {};
                    myDQE.ajax(url, function(data) {
                        if (!data || !data['suggest']) return [];
                        response(data['suggest']);
                    });
                },
                minLength: 0,
                delay: 0,
                create: function() {
                    $(this).data('ui-autocomplete')._renderItem = myDQE.render_item;
                },
                open: function(event, ui) {
                    $(this).data("ui-autocomplete").menu.element.scrollTop(0);
                    $('.ui-autocomplete').css('max-height', '150px').css('overflow-y', 'auto').css('overflow-x', 'hidden');
                },
                select: function(event, ui) {
                    myDQE.trigger('suggest', ui.item);
                    return true;
                },
                close: function( event, ui ) {
                    var value = $(this).val();
                    if (value && value.charAt(value.length - 1) === "@") {
                        $(this).autocomplete("search", value);
                    }
                },
                focus: function(event, ui) {
                    event.preventDefault();
                }
            }).focus(function() {
                if ($(this).data('ui-autocomplete')) $(this).autocomplete("search", $(this).val());
            });
        }

        myDQE.url = function(data) {
            var parameters = [];
            for (var key in data) {
                if (!data.hasOwnProperty(key) || key === "fn" || key === "server") continue;
                parameters.push(key + "=" + encodeURIComponent(data[key]));
            }

            var license = '';
            if(myDQE.oauth === 1){
                license = encodeURIComponent(myDQE.token);
            } else {
                license = myDQE.license;
            }

            return 'https://prod3.dqe-software.com/' + data["fn"] + "/?" + parameters.join("&") + "&Licence=" + license;
        };

        //On enlève les icônes affichant l'état lorsque le champ est modifié
        if (myDQEIcon) {
            myDQE.on("keypress", function() {
                myDQE.clearBootstrapState();
            });
        }

        myDQE.auth = function (client_secret) {
            var timeout;
            var licence = myDQE.license ? myDQE.license : '';
            var token_url = "https://prod3.dqe-software.com/oauth/access_token/?client_secret=" + client_secret + "&grant_type=" + myDQE.grant_type + "&client_id=" + licence;
            myDQE.ajax(token_url, function(data) {
                myDQE.token = data.access_token;
                myDQE.refreshToken = data.refresh_token;
                timeout = data.expires_in;
            });
        };

        if(myDQE.oauth === 1){
            myDQE.auth(myDQE.client_secret);
            setInterval(function() {
                myDQE.auth(myDQE.client_secret);
            }, myDQE.tokenTimeout);
        }

        return myDQE;
    };

}( jQuery ));
